var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ivu-footer-toolbar"},[(_vm.extra || _vm.$slots.extra)?_c('div',{staticClass:"ivu-footer-toolbar-left"},[_vm._t("extra",[_vm._v(_vm._s(_vm.extra))])],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ivu-footer-toolbar-right"},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/footer-toolbar/footer-toolbar.vue